import type { EquippedCosmetic } from '@shared/protocol';
import { resolveAssetUrl } from '@/shop/assetUrl';

const DEFAULT_CSS = 'linear-gradient(180deg, #1E1B4B 0%, #0E0B2E 60%, #050314 100%)';
const DEFAULT_LANES = [0x5a5358, 0x3d3739, 0x2a2528, 0x1c1a1d] as const;

export interface MatchBackgroundTheme {
  cssBackground: string;
  laneColors: readonly [number, number, number, number];
  laneOpacity: number;
  isCustom: boolean;
}

function hexColor(value: unknown, fallback: number): number {
  if (typeof value !== 'string' || !/^#[0-9a-f]{6}$/i.test(value)) return fallback;
  return Number.parseInt(value.slice(1), 16);
}

export function resolveMatchBackgroundTheme(
  cosmetic: EquippedCosmetic | null | undefined,
): MatchBackgroundTheme {
  if (!cosmetic) {
    return {
      cssBackground: DEFAULT_CSS,
      laneColors: [...DEFAULT_LANES],
      laneOpacity: 1,
      isCustom: false,
    };
  }

  const data = cosmetic.data ?? {};
  const image = resolveAssetUrl(
    (data.imageUrl as string | undefined) ?? cosmetic.iconUrl ?? null,
  );
  const authoredBackground = typeof data.background === 'string'
    ? data.background
    : DEFAULT_CSS;
  const rawColors = Array.isArray(data.laneColors) ? data.laneColors : [];
  const opacity = Number(data.laneOpacity);

  return {
    cssBackground: image
      ? `linear-gradient(rgba(5,3,20,.16), rgba(5,3,20,.5)), url("${image}") center / cover no-repeat`
      : authoredBackground,
    laneColors: [
      hexColor(rawColors[0], DEFAULT_LANES[0]),
      hexColor(rawColors[1], DEFAULT_LANES[1]),
      hexColor(rawColors[2], DEFAULT_LANES[2]),
      hexColor(rawColors[3], DEFAULT_LANES[3]),
    ],
    laneOpacity: Number.isFinite(opacity)
      ? Math.min(1, Math.max(0.35, opacity))
      : 0.82,
    isCustom: true,
  };
}
